export const tableContainerSx = {
  borderRadius: '8px',
  marginTop: '0px',
  minHeight: '80vh',
}

export const tableRowBoxSx = (column) => ({
  display: 'flex',
  justifyContent: column.aline,
  alignItems: 'center',
})

export const getTableRowTypographySx = (column) => ({
  fontSize: '13px',
  fontWeight: '500',
  textAlign: column.textAlign ?? 'center',
})
